import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const DeviceRegisterFloor = () => {
  const { planList } = useSelector(({ device }) => device);

  return (
    <DeviceRegisterFloorBlock>
      {planList.map((plan, idx) => (
        <Link to={plan.floor} key={idx}>
          <DeviceRegisterFloorItem plan={plan}>
            {plan.floor}
          </DeviceRegisterFloorItem>
        </Link>
      ))}
    </DeviceRegisterFloorBlock>
  );
};

export default DeviceRegisterFloor;

const DeviceRegisterFloorBlock = styled.div`
  margin-top: 2rem;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 18px;
`;

const DeviceRegisterFloorItem = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;
